/*
  This button is less eye-catching than the primary button, but still very much useful for main actions.

  It’s monochromatic:
  • In light mode, it’s a high-contrast dark gray
  • In dark mode, it has a transparent background and a light gray outline

  Use it either for secondary actions, or for primary actions where I don’t want a super-bright eye-catching button.
*/

import { styled } from '@linaria/react';

import { DarkWrapper } from '@/components/ColorModeContainer';

import ButtonPlayful from './ButtonPlayful';

const ButtonPrimary = styled(ButtonPlayful)`
  --pb-background-color: var(--color-primary);
  --pb-highlight-color: var(--color-primary-light);

  ${DarkWrapper} & {
    /* HACK: This is a duplicate of --wham-primary-500, but I didn’t want to use a course-specific variable in this broadly-reusable component. */
    --pb-background-color: oklch(0.87 0.2 90);
    --pb-highlight-color: oklch(0.95 0.15 90);

    --selection-background-color: var(--pb-highlight-color);
    --selection-text-color: black;

    color: black;
  }
`;

export default ButtonPrimary;
